document.addEventListener('DOMContentLoaded', function() {
  var grid = document.getElementById('products-grid');
  if (!grid) return;
  if (!document.body.classList.contains('template-collection')) return;
  var cards = Array.from(grid.querySelectorAll('.product-col'));
  if (!cards.length) return;
  var grades = [];
  cards.forEach(function(card) {
    var titleEl = card.querySelector('.shopify-loop-product__title');
    if (!titleEl) return;
    var title = titleEl.textContent.trim();
    var parts = title.split(' - ');
    var grade = parts.length > 1 ? parts[parts.length - 1].trim() : null;
    card.setAttribute('data-grade', grade || '');
    if (grade && grades.indexOf(grade) === -1) grades.push(grade);
  });
  if (grades.length < 2) return;
  var nav = document.createElement('div');
  nav.className = 'bliss-grade-nav';
  var allPill = document.createElement('div');
  allPill.className = 'bliss-grade-pill active';
  allPill.textContent = 'All grades';
  allPill.setAttribute('data-filter', '');
  nav.appendChild(allPill);
  var gradeOrder = ['Kindergarten','First Grade','Second Grade','Third Grade','Fourth Grade','Fifth Grade','Sixth Grade','Seventh Grade','Eighth Grade','Ninth Grade','Tenth Grade','Eleventh Grade','Twelfth Grade'];
  grades.sort(function(a, b) {
    var ai = gradeOrder.indexOf(a);
    var bi = gradeOrder.indexOf(b);
    if (ai === -1 && bi === -1) return a.localeCompare(b);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
  grades.forEach(function(grade) {
    var pill = document.createElement('div');
    pill.className = 'bliss-grade-pill';
    var short = grade.replace(' Grade', '').replace('Kindergarten', 'K');
    pill.textContent = short;
    pill.setAttribute('data-filter', grade);
    nav.appendChild(pill);
  });
  var collectionMain = document.getElementById('collection-main');
  if (collectionMain) collectionMain.insertBefore(nav, collectionMain.firstChild);
  nav.addEventListener('click', function(e) {
    var pill = e.target.closest('.bliss-grade-pill');
    if (!pill) return;
    nav.querySelectorAll('.bliss-grade-pill').forEach(function(p) { p.classList.remove('active'); });
    pill.classList.add('active');
    var filter = pill.getAttribute('data-filter');
    cards.forEach(function(card) {
      if (!filter || card.getAttribute('data-grade') === filter) {
        card.classList.remove('bliss-hidden');
      } else {
        card.classList.add('bliss-hidden');
      }
    });
  });
  var collectionContent = document.querySelector('.collection-content');
  if (collectionContent) {
    var trustBar = document.createElement('div');
    trustBar.className = 'bliss-bottom-trust';
    trustBar.innerHTML = '<span><span class="bt-dot"></span>First Day Guarantee</span><span><span class="bt-dot"></span>Free shipping sitewide</span><span><span class="bt-dot"></span>100% list-accurate</span><span><span class="bt-dot"></span>Lafayette, LA since 2020</span>';
    collectionContent.appendChild(trustBar);
  }
});